var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"selection_calendar_background"},[_c('div',{staticClass:"title_card_container"},[_vm._t("icon"),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])],2),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }